module.exports = __webpack_public_path__ + "static/media/22.c5b694c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/22.jpg
// module id = 712
// module chunks = 0